import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { stepReducer } from 'state/steps/StepReducer';
import { canContinueReducer } from 'state/canContinue/CanContinueReducer';
import { setDeceasedDetailsReducer } from 'state/deceasedDetails/DeceasedDetailsReducer';
import { setDeceasedDetailsEnabledReducer } from './deceasedDetailsEnabled/DeceasedDetailsEnabledReducer';
import { setPersonalDetailsReducer } from 'state/personalDetails/PersonalDetailsReducer';
import { setUploadFileResultsReducer } from 'state/uploadFile/UploadFileReducer';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import {
  contentFragmentInErrorReducer,
  contentFragmentReducer,
} from 'state/contentFragments/ContentFragmentReducer';
import {
  sessionTimerTimestampInitialState,
  sessionTimerReducer,
} from 'state/sessionTimer/SessionTimerReducer';
import {
  submitRequestStatusReducer,
  schedulingLinkReducer,
  caseNumberReducer,
} from 'state/submitNotification/SubmitNotificationReducer';

export const browserHistory = createBrowserHistory();
const reactRouterMiddleware = routerMiddleware(browserHistory);
const middlewares = [reactRouterMiddleware];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const initialState = {
  currentStep: 0,
  canContinue: false,
  deceasedDetails: {
    dfName: '',
    dmName: '',
    dlName: '',
    dSuffix: '',
    dAddress: {
      dAddressMilitary: false,
      dAddressOne: '',
      dAddressTwo: '',
      dAddressCity: '',
      dAddressState: '',
      dAddressZip: '',
    },
    dDOB: '',
    dSSN: '',
    dAccountNum: '',
    dDeathCert: null,
    dDOD: '',
  },
  deceasedDetailsEnabled: {
    enableAddress: false,
    enableDOB: false,
    enableSSN: false,
    enableAccountNum: false,
    enableDeathCert: true,
  },
  personalDetails: {
    pfName: '',
    pmName: '',
    plName: '',
    pSuffix: '',
    pPhoneNum: '',
    pEmail: '',
    pPhoneNumFormatted: '',
    pAddress: {
      pAddressMilitary: false,
      pAddressOne: '',
      pAddressTwo: '',
      pAddressCity: '',
      pAddressState: '',
      pAddressZip: '',
    },
    pRelationToDeceased: '',
    pExecutor: '',
  },
  contentFragments: {},
  contentFragmentError: false,
  sessionTimerTimestamp: sessionTimerTimestampInitialState,
  submitRequestStatus: null,
  schedulingLink: null,
  uploadFile: null,
};

export default createStore(
  combineReducers({
    canContinue: canContinueReducer,
    contentFragments: contentFragmentReducer,
    contentFragmentError: contentFragmentInErrorReducer,
    currentStep: stepReducer,
    deceasedDetailsEnabled: setDeceasedDetailsEnabledReducer,
    deceasedDetails: setDeceasedDetailsReducer,
    personalDetails: setPersonalDetailsReducer,
    submitRequestStatus: submitRequestStatusReducer,
    uploadFile: setUploadFileResultsReducer,
    sessionTimerTimestamp: sessionTimerReducer,
    schedulingLink: schedulingLinkReducer,
    caseNumber:caseNumberReducer,
  }),
  initialState,
  composeEnhancers(applyMiddleware(...middlewares))
);
